import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { ReactComponent as LanguageIcon } from "../../images/icons/LanguageIcon.svg";
import { ReactComponent as ArrowIcon } from "../../images/icons/UpArrow.svg";


const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "tr", label: "Türkçe" },
  { code: "pt", label: "Português" },
  { code: "it", label: "Italiano" }
];

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleSelect = (code) => { setLanguage(code); setOpen(false); };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div className="icon-with-arrow" ref={ref}>

      <button className="langButton" onClick={() => setOpen(!open)}>
        <LanguageIcon className="nav-icon-language"/>
        <span className="lang-code">{language.toUpperCase()}</span>
      </button>
      
      <ArrowIcon className={`nav-arrow ${open ? "open" : ""}`} />

      {open && (
        <ul className="language-dropdown_1">
          {LANGUAGES.map(lang => (
            <li
              key={lang.code}
              className="language-dropmenu-item"
              onClick={() => handleSelect(lang.code)}
            >
              {lang.label.toUpperCase()}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
